import merge from 'lodash/merge';

export const webappRoutes = {
  HOMEPAGE: {
    INDEX: '/',
  },
  ABOUT_US: {
    INDEX: '/about-us',
  },
  ACADEMIES: {
    ADMIN: {
      INDEX: '/spaces/admin/academies',
      CREATE: '/spaces/admin/academies/create',
      EDIT: '/spaces/admin/academies/:id',
    },
  },
  ACCOUNT: {
    INDEX: '/account',
    ACCOMODATIONS: '/account/accomodations',
    ACCOMODATIONS_FIELD: '/account/accomodations/:field',
    ADDRESS_CONTACT: '/account/address-contact',
    ADDRESS_CONTACT_FIELD: '/account/address-contact/:field',
    IDENTITY: '/account/identity',
    IDENTITY_FIELD: '/account/identity/:field',
    JOB_PREFERENCES: '/account/job-preferences',
    JOB_PREFERENCES_FIELD: '/account/job-preferences/:field',
    LANGUAGES: '/account/languages',
    LANGUAGES_FIELD: '/account/languages/:field',
    PRESENTATION: '/account/presentation',
    PRESENTATION_FIELD: '/account/presentation/:field',
    PROFESSIONAL_EXPERIENCES: '/account/professional-experiences',
    PROFESSIONAL_EXPERIENCES_FIELD: '/account/professional-experiences/:field',
    SITUATION: '/account/situation',
    SITUATION_FIELD: '/account/situation/:field',
    STATUSES_AND_ALLOWANCES: '/account/statuses-and-allowances',
    STATUSES_AND_ALLOWANCES_FIELD: '/account/statuses-and-allowances/:field',
    TRAINING_ACTIVITIES: '/account/training-activities',
    TRAINING_ACTIVITIES_FIELD: '/account/training-activities/:field',
  },
  ADMIN: {
    SUBSCRIPTIONS_UNENROLL: '/spaces/admin/subscriptions/:subscription_id/unenroll',
    ORGANIZATIONS: {
      INDEX: '/spaces/admin/organizations',
      CREATE: '/spaces/admin/organizations/create',
      EDIT: '/spaces/admin/organizations/:id',
      TEAMS: '/spaces/admin/organizations/:id/teams',
      CREATE_TEAM: '/spaces/admin/organizations/:id/teams/create',
    },
    STUDENTS: {
      SESSIONS_MENTORING_DETAILS: '/spaces/admin/students/:studentId/sessions/mentoring/:sessionId',
    },
  },
  APPLICATION: {
    INDEX: '/application',
    WELCOME: '/application/welcome',
    INTERESTS: '/applications/:id/interests',
    CONTACT: '/applications/:id/contact',
    THANKS: '/applications/:id/thank-you',
    PERSONAL_DETAILS: '/applications/:id/personal-details',
    OCCUPATIONAL_STATUS: '/applications/:id/occupational-status',
    WORK_LOCATION: '/applications/:id/work-location',
    EDUCATION: '/applications/:id/education',
    LEARNING_RESOURCES: '/applications/:id/learning-resources',
    CAREER_CHANGE: '/applications/:id/career-change',
    VIDEO_MOTIVATION: '/applications/:id/video-response',
    VAE: '/applications/:id/vae',
    FUNDING: '/applications/:id/funding',
    SWORN_STATEMENT: '/applications/:id/sworn-statement',
  },
  JOB_APPLICATIONS: {
    INDEX: '/job-applications/:id',
  },
  APPRENTICESHIP: {
    INDEX: '/apprenticeship',
  },
  APPRENTICESHIP_ONBOARDING: {
    START: '/apprenticeship-candidate-onboarding/start',
    QUESTIONS: '/apprenticeship-candidate-onboarding/questions',
  },
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    REGISTER_EMAIL: '/register/email',
    CHECK_DETAILS: '/check-details',
  },
  BUSINESS: {
    INDEX: '/business',
    BOOST: '/business/boost',
    SPARK: '/business/spark',
    PIVOT: '/business/pivot',
    UPLIFT: '/business/uplift',
    CONTACT: '/business/contact',
    CONTACT_CONFIRMATION: '/business/contact/confirmation',
  },
  CERTIFICATIONS: {
    ADMIN: {
      INDEX: '/spaces/admin/certifications',
      CHOOSE_TYPE: '/spaces/admin/certifications/choose-type',
      CREATE: '/spaces/admin/certifications/create',
      EDIT: '/spaces/admin/certifications/:id',
    },
  },
  CERTIFICATION_AUTHORITIES: {
    ADMIN: {
      INDEX: '/spaces/admin/certification-authorities',
      CREATE: '/spaces/admin/certification-authorities/create',
      EDIT: '/spaces/admin/certification-authorities/:id',
    },
  },
  CERTIFICATION_BUSINESS_PARTNERS: {
    ADMIN: {
      INDEX: '/spaces/admin/certification-business-partners',
      CREATE: '/spaces/admin/certification-business-partners/create',
      EDIT: '/spaces/admin/certification-business-partners/:id',
    },
  },
  CERTIFICATION_HOLDERS: {
    ADMIN: {
      INDEX: '/spaces/admin/certification-holders',
      CREATE: '/spaces/admin/certification-holders/create',
      EDIT: '/spaces/admin/certification-holders/:id',
    },
  },
  CIRR: {
    INDEX: '/your-objective',
  },
  COMMUNITY_PATHS: {
    ADMIN: {
      TO_CREATE: '/spaces/admin/communities/paths-to-create',
      CREATED: '/spaces/admin/communities/paths-created',
      DISABLED: '/spaces/admin/communities/paths-disabled',
      CREATE: '/spaces/admin/communities/paths/:communityPathId/create',
      EDIT: '/spaces/admin/communities/paths/:communityPathId/edit',
    },
  },
  COURSES: {
    INDEX: '/courses',
  },
  PROFILE_COMPLETION: {
    INDEX: '/profile-completion',
  },
  CPF: {
    INDEX: '/cpf',
  },
  DIPLOMA: {
    PREVIEW: '/diplomas/:id/preview',
  },
  DASHBOARD: {
    INDEX: '/dashboard',
    PATHS: '/dashboard/paths',
    COURSES: '/dashboard/courses',
    FOLLOWED_COURSES: '/dashboard/courses/followed',
    COMPLETED_COURSES: '/dashboard/courses/completed',
    USER_FOLLOWED_COURSES: '/users/:userId/dashboard/courses/followed',
    USER_COMPLETED_COURSES: '/users/:userId/dashboard/courses/completed',
    ENROLLMENT: '/dashboard/enrollment',
    TRAINING_PLANS: '/dashboard/training-plans',
    TRAINING_PLAN_MODULE: '/dashboard/training-plans/:trainingPlanId/module/:moduleId',
    USER_TRAINING_PLANS: '/users/:userId/dashboard/training-plans',
    USER_TRAINING_PLAN_MODULE:
      '/users/:userId/dashboard/training-plans/:trainingPlanId/module/:moduleId',
    SESSIONS: '/dashboard/sessions',
    SESSIONS_MENTORING_DETAILS: '/dashboard/sessions/mentoring/:sessionId',
    SESSIONS_PRESENTATION_DETAILS: '/dashboard/sessions/presentation/:sessionId',
    PLAYLISTS: '/dashboard/playlists',
    PLAYLIST: '/dashboard/playlists/:playlistId',
    JOB_POSTINGS: '/dashboard/employment/job-postings',
    JOB_POSTING: '/dashboard/employment/job-postings/:jobPostingId',
    APPLY_JOB_POSTING: '/dashboard/employment/job-postings/:jobPostingId/apply',
    JOB_APPLICATIONS: '/dashboard/employment/job-applications',
    JOB_PREFERENCES: '/dashboard/employment/preferences',
    AUTO_APPLY: '/dashboard/employment/auto-apply',
  },
  END_TRAINING: {
    CONGRATULATIONS: '/end-training/congratulations',
    ABOUT_JURY: '/end-training/about-jury',
    ABOUT_COACHING: '/end-training/about-coaching',
    PROOF_OF_COMPLETION: '/end-training/proof-of-completion',
  },
  ENROLLMENT: {
    INFORMATION: {
      INDEX: '/enrollment/information',
      THANK_YOU: '/enrollment/information/thank-you',
    },
  },
  FUNDING: {
    INDEX: '/funding',
    EMPLOYEE: '/funding/employee',
    JOBSEEKER: '/funding/jobseeker',
    FREELANCER: '/funding/freelancer',
    STUDENT: '/funding/student',
    DFE_BOOTCAMPS: '/funding/dfe-bootcamps',
  },
  INVITATIONS: {
    INDEX: '/invitations',
    JOIN: '/invitations/:invitation_id/join',
  },
  JOB_POSTINGS: {
    INDEX: '/job-postings',
    DETAILS: '/job-postings/:jobTypeOrJobId',
    TYPE_DOMAIN: '/job-postings/:jobType/:domain_slug',
    TYPE_DOMAIN_PATH: '/job-postings/:jobType/:domain_slug/:path_slug',
    TYPE_DOMAIN_PATH_LOCALISATION: '/job-postings/:jobType/:domain_slug/:path_slug/:localisation',
  },
  JURY_ASSESSMENTS: {
    INDEX: '/paths/:pathId/users/:userId/jury-assessments',
    SEE_ASSESSMENTS: '/jury-sessions/:id/assessments/:assessmentId',
  },
  JURY_SESSIONS: {
    ADMIN: {
      INDEX: '/spaces/admin/jury-sessions',
      CREATE: '/spaces/admin/jury-sessions/create',
      EDIT: '/spaces/admin/jury-sessions/:id',
      CREATE_STUDENT_CREDENTIAL: '/spaces/admin/jury-sessions/:id/student-credentials/create',
      CREATE_ASSESSMENTS: '/spaces/admin/jury-sessions/:id/assessments/create',
    },
  },
  LEARNING_EXPERIENCE: {
    INDEX: '/learning-experience',
  },
  MATCH_DECLARATIONS: {
    INDEX: '/match-declarations',
    EMPLOYER: '/match-declarations/employer',
    CANDIDATE: '/match-declarations/candidate',
  },
  MENTORSHIP: {
    DASHBOARD: {
      INDEX: '/mentorship/dashboard',
      SESSIONS: '/mentorship/dashboard/sessions',
      SESSIONS_BOOKED: '/mentorship/dashboard/booked-mentorship-sessions',
      SESSIONS_HISTORY: '/mentorship/dashboard/mentorship-sessions-history',
      STUDENTS: '/mentorship/dashboard/students',
      STUDENT_DETAILS: '/mentorship/dashboard/students/:studentId',
      CALENDAR: '/mentorship/dashboard/calendar',
      CALENDAR_EDIT: '/mentorship/dashboard/calendar/edit',
      PREFERENCES: '/mentorship/dashboard/preferences',
      PREFERENCES_INVOICING: '/mentorship/dashboard/preferences-invoicing',
      INVOICING: '/mentorship/dashboard/invoicing',
      SESSIONS_MENTORING_DETAILS: '/mentorship/dashboard/sessions/mentoring/:sessionId',
      SESSIONS_PRESENTATION_DETAILS: '/mentorship/dashboard/sessions/presentation/:sessionId',
      ADMIN_SESSIONS_PRESENTATION_DETAILS:
        '/mentorship/dashboard/sessions/admin/presentation/:sessionId',
      MENTORING_SESSIONS_NEW: '/mentorship/dashboard/sessions/new',
      DEFENSE_SESSIONS_NEW: '/mentorship/dashboard/defense-sessions/new',
    },
  },
  OFFERS: {
    INDEX: '/offers',
  },
  MY_ORGANIZATION: {
    INDEX: '/my-organization/:path',
    OVERVIEW: '/my-organization/overview',
    TALENTS: '/my-organization/talents',
    SHARE_CANDIDATE: '/my-organization/share-candidate',
  },
  ORGANIZATIONS: {
    INDEX: '/organizations/:organizationId',
    ANALYTICS: '/organizations/:organizationId/analytics',
    ANALYTICS_COURSES: '/organizations/:organizationId/analytics/courses',
    ANALYTICS_TRAINING_PROGRAMS: '/organizations/:organizationId/analytics/training-programs',
    INVITATIONS: '/organizations/:organizationId/invitations',
    OVERVIEW: '/organizations/:organizationId/overview',
    SHARE_CANDIDATE: '/organizations/:organizationId/share-candidate',
    TALENTS: '/organizations/:organizationId/talents',
    TALENT_DETAILS: '/organizations/:organizationId/talents/:userId',
    TALENT_SEARCH: '/organizations/:organizationId/talents/searches/:searchId',
    TALENT_SEARCHES: '/organizations/:organizationId/talents/searches',
    TEAMS: '/organizations/:organizationId/teams',
    TEAM_INDEX: '/organizations/:organizationId/teams/:teamId',
    TEAM_SETTINGS: '/organizations/:organizationId/teams/:teamId/settings',
    TEAM_USERS: '/organizations/:organizationId/teams/:teamId/users',
    TEAM_USER: '/organizations/:organizationId/teams/:teamId/users/:userId',
    TEAM_PENDING_INVITATIONS: '/organizations/:organizationId/teams/:teamId/invitations',
    TEAM_USER_INVITATIONS: '/organizations/:organizationId/teams/:teamId/users/invite',
    USERS: '/organizations/:organizationId/users',
    USER_EDIT: '/organizations/:organizationId/users/:userId',
    USER_INVITATIONS: '/organizations/:organizationId/users/invite',
    JOB_POSTINGS: '/organizations/:organizationId/job-postings',
  },
  PARTNERS: {
    INDEX: '/partners',
    SPARK_APPLY: '/partners/:partner/apply/spark',
    APPLICATION_COMPLETE: '/partners/:partner/complete-application',
  },
  PATH: {
    OUTCOMES: '/paths/:pathId/student-outcomes',
  },
  POLICIES: {
    TERMS_CONDITION: '/policies/terms-conditions',
    TERMS_SALES: '/policies/terms-of-sale',
    PRIVACY_POLICY: '/policies/privacy-policy',
    INTERNAL_STUDENTS_RULES: '/policies/internal-rules-for-students',
    LEGAL_INFORMATION: '/policies/legal-information',
  },

  PROFILE: {
    INDEX: '/profile',
    VIEW_AS: '/profile/view-as/:persona',
    VIEW_AS_EDIT: '/profile/view-as/:persona/:field',
    VIEW_AS_EDIT_SPECIFIC: '/profile/view-as/:persona/:field/:id',

    /**
     * Redirects temporarily to the user account
     */
    EDIT: '/profile/:field',
    EDIT_SPECIFIC: '/profile/:field/:id',
  },

  PROOF_OF_COMPLETION: {
    INDEX: '/proof-of-completion/:pathId',
  },

  RESUME: {
    APPRENTICESHIP: '/resume/apprenticeship/:userId',
  },
  SEARCH: {
    INDEX: '/search',
  },
  SECURITY: {
    SET_NEW_PASSWORD: '/set-new-password',
    GENERATE_PASSWORD: '/generate-password',
    CONFIRM_PASSWORD: '/confirm-new-password/:userId',
    SECURITY_PAGE: '/security',
  },
  STANFORD_COURSES: {
    INDEX: '/stanford-courses/:idSlug',
  },
  STUDENT_APPLICATION: {
    QUESTION: '/student-applications/:id/:step/:questionId',
  },
  STUDENT_CONFIRMATION: {
    INDEX: '/student-confirmation',
  },
  STUDENT_CREDENTIALS: {
    PARCHMENT: {
      DOWNLOAD: '/student-credentials/:credentialNumber/parchment',
    },
    ADMIN: {
      INDEX: '/spaces/admin/student-credentials',
      EDIT: '/spaces/admin/student-credentials/:id',
    },
  },
  SUBSCRIPTIONS: {
    UNENROLL: '/subscriptions/:subscription_id/unenroll',
    PATH_ID_ERROR: '/subscriptions/paths/:pathId/path-error',
    SUBSCRIBE: '/subscriptions/subscribe/:pathSlug',
  },
  SURVEYS: {
    CAREER: {
      INDEX: '/users/:userId/survey/career/path/:pathId',
      END: '/users/:userId/survey/career/path/:pathId/end',
      JOB_SEEKER: '/users/:userId/survey/career/path/:pathId/job-seeker',
      NO_ACTIVITY: '/users/:userId/survey/career/path/:pathId/no-activity',
      TRAINING: '/users/:userId/survey/career/path/:pathId/training',
      BUSINESS_OWNER: '/users/:userId/survey/career/path/:pathId/business-owner',
      EMPLOYEE_CONTRACT: '/users/:userId/survey/career/path/:pathId/employee/contract',
      EMPLOYEE_ENTERPRISE: '/users/:userId/survey/career/path/:pathId/employee/enterprise',
    },
  },
  TALENTS: {
    LIST: '/talents',
    DETAILS: '/talents/:userId',
    SEARCH: '/talents/searches/:searchId',
  },
  TEAMS: {
    ANALYTICS: '/teams/:teamId/analytics',
    ANALYTICS_COURSES: '/teams/:teamId/analytics/courses',
    INVITATIONS: '/teams/:teamId/invitations',
    PLAYLISTS: '/teams/:teamId/playlists',
    PLAYLISTS_NEW: '/teams/:teamId/playlists/new',
    PLAYLIST_INDEX: '/teams/:teamId/playlists/:playlistId',
    PLAYLIST_USERS: '/teams/:teamId/playlists/:playlistId/users',
    PLAYLIST_USERS_ADD: '/teams/:teamId/playlists/:playlistId/users/add',
    PLAYLIST_COURSES: '/teams/:teamId/playlists/:playlistId/courses',
    PLAYLIST_COURSES_EDIT: '/teams/:teamId/playlists/:playlistId/courses/edit',
    SHOW: '/teams/:teamSlug',
    USERS: '/teams/:teamId/users',
    USER: '/teams/:teamId/users/:userId',
    ANALYTICS_TRAINING_PROGRAMS: '/teams/:teamId/analytics/training-programs',
    SETTINGS: '/teams/:teamId/settings',
    USER_INVITATIONS: '/teams/:teamId/users/invite',
    TALENTS: '/teams/:teamId/talents',
    TALENT_DETAILS: '/teams/:teamId/talents/:userId',
    TALENT_SEARCH: '/teams/:teamId/talents/searches/:searchId',
  },
  TUTOR: {
    DASHBOARD: {
      INDEX: '/tutor/dashboard',
      DETAIL: '/tutor/dashboard/:studentId',
      PROJECT: '/tutor/dashboard/:studentId/projects/:projectId',
      TRAINING_PLAN_MODULE:
        '/tutor/dashboard/:studentId/training-plans/:trainingPlanId/module/:moduleId',
    },
  },
  UK_APPRENTICESHIP: {
    INDEX: '/uk-apprenticeship',
  },
  UK_BUSINESS: {
    INDEX: '/uk-apprenticeship-for-business',
  },
  US_BUSINESS: {
    INDEX: '/us-apprenticeship-for-business',
  },
  VAP: {
    INDEX: '/vap/:config',
    WELCOME: '/vap/:config/welcome',
    THANKS: '/vap/:config/thank-you',
    MOTIVATIONS: '/vap/:config/motivations',
    EDUCATION: '/vap/:config/education',
    PROFESSIONAL_CAREER: '/vap/:config/professional-career',
    COMPETENCIES: '/vap/:config/competencies',
  },
  VIDEO_CONFERENCE: {
    MEET: '/video-conferences/:id/meet',
    CALL: '/video-conferences/:id/meet/call',
    END: '/video-conferences/:id/meet/end',
    SETTINGS: {
      INDEX: '/video-conferences/:id/meet/settings',
      CAMERA: '/video-conferences/:id/meet/settings/camera',
      MIC: '/video-conferences/:id/meet/settings/mic',
      SPEAKER: '/video-conferences/:id/meet/settings/speaker',
      END: '/video-conferences/:id/meet/settings/end',
    },
  },

  WELCOME: {
    INDEX: '/welcome',
    OFFER_DIPLOMA: '/welcome/offer-diploma',
    EMPLOYER_PHONE_NUMBER: '/welcome/employer-phone-number',
    STUDENT_WELCOME: '/student-welcome',
    LEARNING_JOURNEY_INTRODUCTION: '/learning-journey-introduction',
    PATH_START: '/path-start',
    SPARK: '/welcome/spark',
    ORGANIZATION: '/welcome/organization',
    RECRUITER: {
      INDEX: '/welcome/recruiter',
      JOB_POSTINGS: {
        REQUIREMENTS: '/welcome/recruiter/job-postings/requirements',
        RECRUITMENT_OPTIONS: '/welcome/recruiter/job-postings/recruitment-options',
        PREVIEW: '/welcome/recruiter/job-postings/preview',
      },
    },
  },
};

const legacyRoutes = {
  COURSES: {
    DETAIL: '/courses/:courseIdSlug',
    CHAPTERS: '/courses/:courseIdSlug/:chapterIdSlug',
    EXERCISES: '/courses/:courseIdSlug/exercises/:exerciseId',
  },
  PATH: {
    INDEX: '/paths',
    DETAIL: '/paths/:pathId',
    SUPPORT_TAB: '/paths/:pathId/support',
    PROJECT: '/paths/:pathId/projects/:projectId/:page', // Student view
    PROJECT_HOMEPAGE: '/paths/:pathId/projects/:projectId', // Student view
    ADMIN: {
      CREATE: '/spaces/admin/paths/create',
    },
    SYLLABUS: '/paths/:pathSlug/pdf',
    APPRENTICESHIP_SYLLABUS: '/paths/:pathSlug/apprenticeshippdf',
  },
  ADMIN: {
    DASHBOARD: '/spaces/admin',
    INDEX: '/spaces/admin',
    SUBSCRIPTIONS_UNENROLL: '/spaces/admin/subscriptions/:subscription_id/unenroll',
    MENTOR: '/spaces/admin/mentors/:mentor_id',
    ORGANIZATIONS: {
      INDEX: '/spaces/admin/organizations',
      CREATE: '/spaces/admin/organizations/create',
      EDIT: '/spaces/admin/organizations/:id/edit',
      TEAMS: '/spaces/admin/organizations/:id/teams',
      CREATE_TEAM: '/spaces/admin/organizations/:id/teams/create',
    },
    PROJECTS: {
      INDEX: '/spaces/admin/project-versions',
      VIEW: '/spaces/admin/project-versions/:id/view',
      CREATE: '/spaces/admin/project-versions/create',
    },
    USERS: {
      PREMIUM: '/spaces/admin/users/:userId/premium',
    },
    STUDENTS: {
      INDEX: '/spaces/admin/students',
      DASHBOARD: '/spaces/admin/students/:studentId',
      EDIT: '/spaces/admin/students/:studentId/edit',
      PROJECT_EVALUATION:
        '/spaces/admin/students/:studentId/projects/:projectId/project-evaluation',
      PROJECT: '/spaces/admin/students/:studentId/projects/:projectId/:page',
      PATH_PROJECT: '/spaces/admin/students/:studentId/paths/:pathId/projects/:projectId/:page',
      SESSIONS_MENTORING_DETAILS: '/spaces/admin/students/:studentId/sessions/mentoring/:sessionId',
      PATH_PROJECT_HOMEPAGE: '/spaces/admin/students/:studentId/paths/:pathId/projects/:projectId',
      PROJECT_HOMEPAGE: '/spaces/admin/students/:studentId/projects/:projectId',
      TRAINING_PLAN_MODULE:
        '/spaces/admin/students/:studentId/training-plans/:trainingPlanId/module/:moduleId',
      TRAINING_PLAN: '/spaces/admin/students/:studentId/training-plans/:trainingPlanId',
    },
  },
  USER: {
    INDEX: '/users/:userId',
    PROJECT: '/users/:userId/projects/:projectId/:page', // Mentor view with student context (legacy)
    PROJECT_HOMEPAGE: '/users/:userId/projects/:projectId', // Mentor view with student context (legacy)
    PROJECT_EVALUATION: '/users/:userId/projects/:projectId/project-evaluation',
    PATH_PROJECT: '/users/:userId/paths/:pathId/projects/:projectId/:page', // Mentor view with student context
    PATH_PROJECT_HOMEPAGE: '/users/:userId/paths/:pathId/projects/:projectId', // Mentor view with student context
    PATH_PROOF_OF_COMPLETION_DOWNLOAD: `/users/:userId/paths/:pathId/proof-of-completion`,
  },
  PROJECT: {
    INDEX: '/projects/:projectId',
    PAGE: '/projects/:projectId/:page',
    HOMEPAGE: '/projects/:projectId',
    EVALUATION: '/projects/:projectId/project-evaluation',
    ADMIN: {
      INDEX: '/spaces/admin/projects',
      CREATE: '/spaces/admin/projects/create',
      OVERVIEW_EDIT: '/spaces/admin/projects/:projectId/overview',
      CONTENT_EDIT: '/spaces/admin/projects/:projectId/content',
      MENTOR_GUIDE_EDIT: '/spaces/admin/projects/:projectId/mentor-guide',
      EVALUATION_EDIT: '/spaces/admin/projects/:projectId/evaluation',
      EXTERNAL_RESOURCES: '/spaces/admin/projects/:projectId/external-resources',
      EXTERNAL_RESOURCES_CREATE: '/spaces/admin/projects/:projectId/external-resources/create',
      EXTERNAL_RESOURCES_EDIT:
        '/spaces/admin/projects/:projectId/external-resources/:externalResourceId',
      SECTIONS: '/spaces/admin/projects/:projectId/sections',
      SECTION_CREATE: '/spaces/admin/projects/:projectId/sections/create',
      SECTION_EDIT: '/spaces/admin/projects/:projectId/sections/:sectionId',
      MILESTONE_CREATE: '/spaces/admin/projects/:projectId/sections/:sectionId/milestones/create',
      MILESTONE_EDIT:
        '/spaces/admin/projects/:projectId/sections/:sectionId/milestones/:milestoneId',
      STUDENT: {
        INDEX: '/spaces/admin/students/:studentId/projects/:projectId',
        PATH: {
          INDEX: '/spaces/admin/students/:studentId/paths/:pathId/projects/:projectId',
        },
      },
    },
    USER: {
      INDEX: '/users/:userId/projects/:projectId',
      PATH: {
        INDEX: '/users/:userId/paths/:pathId/projects/:projectId',
      },
    },
    PATH: {
      INDEX: '/paths/:pathId/projects/:projectId',
    },
  },
  MEMBERS: {
    SHOW: '/members/:id',
    PARAMETERS: '/members/:id/parameters',
    EDIT: '/members/:id/edit',
  },
  MENTORS: {
    EDIT: '/mentors/:mentorId/edit',
  },

  CERTIFICATE_SIGNATORIES: {
    ADMIN: {
      CREATE: '/spaces/admin/certificate-signatories/new',
    },
  },
};

const routes = merge({}, webappRoutes, legacyRoutes);

export default routes;
